export function modelPolicyPath(base: string, seriesId?: string) {
  return `${base}${seriesId ? `/series/${seriesId}` : ''}/model-policy`;
}

export function submittedAudioSettings<
  T extends { visualMode: string; audioMode?: 'native' | 'tts'; narratorVoiceId?: string },
>(settings: T) {
  return {
    ...settings,
    audioMode: settings.audioMode ?? (settings.visualMode === 'image' ? 'tts' : 'native'),
    narratorVoiceId: settings.narratorVoiceId?.trim() || 'eve',
  };
}

export function requestedEpisode<T extends { id: string }>(episodes: T[], requestedId: string) {
  return requestedId ? episodes.find((episode) => episode.id === requestedId) : episodes[0];
}

export function sameDraft(left: unknown, right: unknown) {
  return JSON.stringify(left) === JSON.stringify(right);
}

type AudioVisualSettings = {
  visualMode: string;
  audioMode?: string;
  voiceModelId?: string;
  narratorVoiceId?: string;
};
export function configurationImpact(
  stage: string,
  old: AudioVisualSettings,
  next: AudioVisualSettings,
) {
  const visualChanged = old.visualMode !== next.visualMode;
  const oldTts = (old.audioMode ?? (old.visualMode === 'image' ? 'tts' : 'native')) === 'tts';
  const nextTts = (next.audioMode ?? (next.visualMode === 'image' ? 'tts' : 'native')) === 'tts';
  const audioChanged =
    oldTts !== nextTts ||
    (nextTts &&
      ((old.voiceModelId ?? '') !== (next.voiceModelId ?? '') ||
        (old.narratorVoiceId?.trim() || 'eve') !== (next.narratorVoiceId?.trim() || 'eve')));
  const rebuild =
    (visualChanged && ['media', 'keyframes'].includes(stage)) ||
    (audioChanged && stage === 'media');
  const blocked = stage === 'render' && (visualChanged || audioChanged);
  const detail = visualChanged
    ? next.visualMode === 'video'
      ? '将取消本集当前画面和配音的选用，重新制作关键帧；批准后再生成视频与声音。'
      : '将取消本集当前画面和配音的选用，重新生成图片与独立配音。'
    : oldTts && !nextTts
      ? '将取消本集当前视频和独立配音的选用，重新生成带对白与声音的视频。'
      : '将重新生成本集的独立配音，现有画面保留。';
  return { rebuild, blocked, changed: visualChanged || audioChanged, detail };
}

export function remoteDraftAction<T>(
  local: { episodeId: string; revision: string; base: T; draft: T } | null,
  incoming: { episodeId: string; revision: string; body: T },
) {
  if (!local || local.episodeId !== incoming.episodeId) return 'load';
  if (BigInt(incoming.revision) <= BigInt(local.revision)) return 'unchanged';
  return sameDraft(local.base, local.draft) ? 'load' : 'conflict';
}
